import React from 'react';
import { SocietyChip } from './SocietySwitcher';
import './SocietyHeaderBadge.css';

/**
 * The society line under a page title — now the society CHIP (SocietySwitcher),
 * so every header that names the society can also change it.
 */
const SocietyHeaderBadge = () => (
    <div className="society-header-badge">
        <SocietyChip variant="header" />
    </div>
);

export default SocietyHeaderBadge;
